// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Games Grid - The critical performance component */
.lE_gfTo4830CiTdj8UeP {
  display: grid;
  justify-items: center;
  align-items: start;
  gap: var(--grid-gap);
  /* Smooth scrolling */
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  /* Custom scrollbar */
  scrollbar-width: none;
  scrollbar-color: var(--border-light) var(--cardBackground);
  /* WebKit scrollbar styles */
}
.lE_gfTo4830CiTdj8UeP::-webkit-scrollbar {
  height: 8px;
  width: 8px;
}
.lE_gfTo4830CiTdj8UeP::-webkit-scrollbar-track {
  background: var(--cardBackground);
  border-radius: 4px;
}
.lE_gfTo4830CiTdj8UeP::-webkit-scrollbar-thumb {
  background: var(--border-light);
  border-radius: 4px;
}
.lE_gfTo4830CiTdj8UeP::-webkit-scrollbar-thumb:hover {
  background: var(--light-grey);
}
.lE_gfTo4830CiTdj8UeP[data-has-jackpot='true'] {
  min-width: 0;
  /* Prevent overflow */
  width: 100%;
}
/* Default behavior */
.lE_gfTo4830CiTdj8UeP[data-view='single'] {
  padding: var(--game-grid-padding);
  padding-top: 0;
  grid-template-columns: repeat(2, 1fr);
  grid-auto-rows: max-content;
  align-content: start;
  /* Prevents vertical spacing between rows */
  justify-items: center;
  /* Center items horizontally in their cells */
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1;
  /* Take up remaining space in section body */
  min-height: 0;
  /* Allow flex child to shrink */
  /* Only show scrollbar when actually needed */
  scrollbar-width: thin;
  /* Smooth scrolling */
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  /* Performance optimization */
  contain: layout style paint;
  will-change: scroll-position;
  /* margin-top: var(--single-section-margin-top); */
}
.lE_gfTo4830CiTdj8UeP[data-view='single'][data-has-jackpot='true'] {
  width: 100%;
  flex: none;
  /* Don't stretch, just take content size */
  min-width: initial;
  overflow: visible;
  /* Don't create its own scroll area */
}
.lE_gfTo4830CiTdj8UeP[data-view='single'][open-type='fullscreen'] {
  padding-bottom: 17px;
}
/* Multi-view: horizontal single-row flexbox */
.lE_gfTo4830CiTdj8UeP[data-view='multi'] {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 0 8px;
  /* Only show scrollbar when actually needed */
  scrollbar-width: none;
  /* Ensure cards maintain their size and don't shrink */
  align-items: center;
  overscroll-behavior-x: none;
  overscroll-behavior-y: auto;
  /* To hide scrollbar on some iOS devices */
}
.lE_gfTo4830CiTdj8UeP[data-view='multi']::-webkit-scrollbar {
  display: none;
}
.lE_gfTo4830CiTdj8UeP[data-view='multi'] {
  padding: 0 8px 8px 14px;
}
@media (orientation: landscape) and (max-width: 1025px) {
  .lE_gfTo4830CiTdj8UeP[data-has-jackpot='true'][data-view='multi'] {
    padding: 40px 20px 40px 0;
  }
}
/* Responsive breakpoints */
@media (max-width: 319px) {
  .lE_gfTo4830CiTdj8UeP[data-view='multi'] {
    padding-left: 8px;
  }
}
@media (min-width: 389px) {
  .lE_gfTo4830CiTdj8UeP[data-view='single'] {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (min-width: 576px) {
  .lE_gfTo4830CiTdj8UeP[data-view='single'] {
    grid-template-columns: repeat(4, 1fr);
  }
  .lE_gfTo4830CiTdj8UeP[data-view='multi'] {
    padding-left: 16px;
  }
}
@media (min-width: 1025px) {
  .lE_gfTo4830CiTdj8UeP[data-view='multi'] {
    padding: 0 20px;
  }
  .lE_gfTo4830CiTdj8UeP[data-view='single'][open-type='fullscreen'] {
    padding: 0 20px 40px var(--game-grid-padding);
  }
  .lE_gfTo4830CiTdj8UeP[data-view='multi'] {
    padding: 0 20px 8px 20px;
  }
}
@media (min-width: 1026px) {
  .lE_gfTo4830CiTdj8UeP[data-view='multi'][data-has-jackpot='true'] {
    padding: 54px 20px 54px 0;
  }
  .lE_gfTo4830CiTdj8UeP[data-view='single'] {
    grid-template-columns: repeat(5, 1fr);
  }
}
@media (min-width: 1280px) {
  .lE_gfTo4830CiTdj8UeP[data-view='single'] {
    grid-template-columns: repeat(6, 1fr);
  }
}
@media (min-width: 1600px) {
  .lE_gfTo4830CiTdj8UeP[data-view='single'] {
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  }
}
@media (pointer: coarse) {
  .lE_gfTo4830CiTdj8UeP[data-view='multi'] {
    scroll-snap-type: x mandatory;
    scroll-padding-left: 30px;
  }
  .lE_gfTo4830CiTdj8UeP[data-view='multi'] > * {
    scroll-snap-align: start;
  }
  .lE_gfTo4830CiTdj8UeP[data-view='multi'] > *:nth-child(n + 10) {
    scroll-margin-left: calc(var(--most-played-num-image-width) - 50px);
  }
  .lE_gfTo4830CiTdj8UeP[data-view='multi'] > *:nth-child(n + 20) {
    scroll-margin-left: calc(var(--most-played-num-image-width) - 35px);
  }
}
/* Tablet landscape (iPad is ≥1026 CSS px in landscape, so the rank number image
   is 160px here). The rank digit hangs ~23% of that image width to the left of
   its card, i.e. ~37px — more than the 30px the snapport exposes, so a snapped
   card had its number clipped on the left. Expose the full overhang instead.
   The 10+/20+ scroll margins are reduced by the same 18px so the wider
   double-digit numbers keep the alignment they were tuned for. */
@media (pointer: coarse) and (min-width: 1026px) {
  .lE_gfTo4830CiTdj8UeP[data-view='multi'] {
    scroll-padding-left: 48px;
  }
  .lE_gfTo4830CiTdj8UeP[data-view='multi'] > *:nth-child(n + 10) {
    scroll-margin-left: calc(var(--most-played-num-image-width) - 68px);
  }
  .lE_gfTo4830CiTdj8UeP[data-view='multi'] > *:nth-child(n + 20) {
    scroll-margin-left: calc(var(--most-played-num-image-width) - 53px);
  }
}
`, "",{"version":3,"sources":["webpack://./src/layouts/Section/TopSectionGrid/TopSectionGrid.module.css"],"names":[],"mappings":"AAAA,oDAAoD;AACpD;EACE,aAAa;EACb,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,uBAAuB;EACvB,iCAAiC;EACjC,qBAAqB;EACrB,qBAAqB;EACrB,0DAA0D;EAC1D,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,iCAAiC;EACjC,kBAAkB;AACpB;AACA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,YAAY;EACZ,qBAAqB;EACrB,WAAW;AACb;AACA,qBAAqB;AACrB;EACE,iCAAiC;EACjC,cAAc;EACd,qCAAqC;EACrC,2BAA2B;EAC3B,oBAAoB;EACpB,2CAA2C;EAC3C,qBAAqB;EACrB,6CAA6C;EAC7C,gBAAgB;EAChB,kBAAkB;EAClB,OAAO;EACP,4CAA4C;EAC5C,aAAa;EACb,+BAA+B;EAC/B,6CAA6C;EAC7C,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,iCAAiC;EACjC,6BAA6B;EAC7B,2BAA2B;EAC3B,4BAA4B;EAC5B,kDAAkD;AACpD;AACA;EACE,WAAW;EACX,UAAU;EACV,0CAA0C;EAC1C,kBAAkB;EAClB,iBAAiB;EACjB,qCAAqC;AACvC;AACA;EACE,oBAAoB;AACtB;AACA,8CAA8C;AAC9C;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,6CAA6C;EAC7C,qBAAqB;EACrB,sDAAsD;EACtD,mBAAmB;EACnB,2BAA2B;EAC3B,2BAA2B;EAC3B,0CAA0C;AAC5C;AACA;EACE,aAAa;AACf;AACA;EACE,uBAAuB;AACzB;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA,2BAA2B;AAC3B;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,qCAAqC;EACvC;AACF;AACA;EACE;IACE,qCAAqC;EACvC;EACA;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,6CAA6C;EAC/C;EACA;IACE,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,qCAAqC;EACvC;AACF;AACA;EACE;IACE,qCAAqC;EACvC;AACF;AACA;EACE;IACE,4DAA4D;EAC9D;AACF;AACA;EACE;IACE,6BAA6B;IAC7B,yBAAyB;EAC3B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,mEAAmE;EACrE;EACA;IACE,mEAAmE;EACrE;AACF;AACA;;;;;iEAKiE;AACjE;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,mEAAmE;EACrE;EACA;IACE,mEAAmE;EACrE;AACF","sourcesContent":["/* Games Grid - The critical performance component */\n.gamesGrid {\n  display: grid;\n  justify-items: center;\n  align-items: start;\n  gap: var(--grid-gap);\n  /* Smooth scrolling */\n  scroll-behavior: smooth;\n  -webkit-overflow-scrolling: touch;\n  /* Custom scrollbar */\n  scrollbar-width: none;\n  scrollbar-color: var(--border-light) var(--cardBackground);\n  /* WebKit scrollbar styles */\n}\n.gamesGrid::-webkit-scrollbar {\n  height: 8px;\n  width: 8px;\n}\n.gamesGrid::-webkit-scrollbar-track {\n  background: var(--cardBackground);\n  border-radius: 4px;\n}\n.gamesGrid::-webkit-scrollbar-thumb {\n  background: var(--border-light);\n  border-radius: 4px;\n}\n.gamesGrid::-webkit-scrollbar-thumb:hover {\n  background: var(--light-grey);\n}\n.gamesGrid[data-has-jackpot='true'] {\n  min-width: 0;\n  /* Prevent overflow */\n  width: 100%;\n}\n/* Default behavior */\n.gamesGrid[data-view='single'] {\n  padding: var(--game-grid-padding);\n  padding-top: 0;\n  grid-template-columns: repeat(2, 1fr);\n  grid-auto-rows: max-content;\n  align-content: start;\n  /* Prevents vertical spacing between rows */\n  justify-items: center;\n  /* Center items horizontally in their cells */\n  overflow-y: auto;\n  overflow-x: hidden;\n  flex: 1;\n  /* Take up remaining space in section body */\n  min-height: 0;\n  /* Allow flex child to shrink */\n  /* Only show scrollbar when actually needed */\n  scrollbar-width: thin;\n  /* Smooth scrolling */\n  scroll-behavior: smooth;\n  -webkit-overflow-scrolling: touch;\n  /* Performance optimization */\n  contain: layout style paint;\n  will-change: scroll-position;\n  /* margin-top: var(--single-section-margin-top); */\n}\n.gamesGrid[data-view='single'][data-has-jackpot='true'] {\n  width: 100%;\n  flex: none;\n  /* Don't stretch, just take content size */\n  min-width: initial;\n  overflow: visible;\n  /* Don't create its own scroll area */\n}\n.gamesGrid[data-view='single'][open-type='fullscreen'] {\n  padding-bottom: 17px;\n}\n/* Multi-view: horizontal single-row flexbox */\n.gamesGrid[data-view='multi'] {\n  display: flex;\n  flex-wrap: nowrap;\n  overflow-x: auto;\n  overflow-y: hidden;\n  padding: 0 8px;\n  /* Only show scrollbar when actually needed */\n  scrollbar-width: none;\n  /* Ensure cards maintain their size and don't shrink */\n  align-items: center;\n  overscroll-behavior-x: none;\n  overscroll-behavior-y: auto;\n  /* To hide scrollbar on some iOS devices */\n}\n.gamesGrid[data-view='multi']::-webkit-scrollbar {\n  display: none;\n}\n.gamesGrid[data-view='multi'] {\n  padding: 0 8px 8px 14px;\n}\n@media (orientation: landscape) and (max-width: 1025px) {\n  .gamesGrid[data-has-jackpot='true'][data-view='multi'] {\n    padding: 40px 20px 40px 0;\n  }\n}\n/* Responsive breakpoints */\n@media (max-width: 319px) {\n  .gamesGrid[data-view='multi'] {\n    padding-left: 8px;\n  }\n}\n@media (min-width: 389px) {\n  .gamesGrid[data-view='single'] {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n@media (min-width: 576px) {\n  .gamesGrid[data-view='single'] {\n    grid-template-columns: repeat(4, 1fr);\n  }\n  .gamesGrid[data-view='multi'] {\n    padding-left: 16px;\n  }\n}\n@media (min-width: 1025px) {\n  .gamesGrid[data-view='multi'] {\n    padding: 0 20px;\n  }\n  .gamesGrid[data-view='single'][open-type='fullscreen'] {\n    padding: 0 20px 40px var(--game-grid-padding);\n  }\n  .gamesGrid[data-view='multi'] {\n    padding: 0 20px 8px 20px;\n  }\n}\n@media (min-width: 1026px) {\n  .gamesGrid[data-view='multi'][data-has-jackpot='true'] {\n    padding: 54px 20px 54px 0;\n  }\n  .gamesGrid[data-view='single'] {\n    grid-template-columns: repeat(5, 1fr);\n  }\n}\n@media (min-width: 1280px) {\n  .gamesGrid[data-view='single'] {\n    grid-template-columns: repeat(6, 1fr);\n  }\n}\n@media (min-width: 1600px) {\n  .gamesGrid[data-view='single'] {\n    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  }\n}\n@media (pointer: coarse) {\n  .gamesGrid[data-view='multi'] {\n    scroll-snap-type: x mandatory;\n    scroll-padding-left: 30px;\n  }\n  .gamesGrid[data-view='multi'] > * {\n    scroll-snap-align: start;\n  }\n  .gamesGrid[data-view='multi'] > *:nth-child(n + 10) {\n    scroll-margin-left: calc(var(--most-played-num-image-width) - 50px);\n  }\n  .gamesGrid[data-view='multi'] > *:nth-child(n + 20) {\n    scroll-margin-left: calc(var(--most-played-num-image-width) - 35px);\n  }\n}\n/* Tablet landscape (iPad is ≥1026 CSS px in landscape, so the rank number image\n   is 160px here). The rank digit hangs ~23% of that image width to the left of\n   its card, i.e. ~37px — more than the 30px the snapport exposes, so a snapped\n   card had its number clipped on the left. Expose the full overhang instead.\n   The 10+/20+ scroll margins are reduced by the same 18px so the wider\n   double-digit numbers keep the alignment they were tuned for. */\n@media (pointer: coarse) and (min-width: 1026px) {\n  .gamesGrid[data-view='multi'] {\n    scroll-padding-left: 48px;\n  }\n  .gamesGrid[data-view='multi'] > *:nth-child(n + 10) {\n    scroll-margin-left: calc(var(--most-played-num-image-width) - 68px);\n  }\n  .gamesGrid[data-view='multi'] > *:nth-child(n + 20) {\n    scroll-margin-left: calc(var(--most-played-num-image-width) - 53px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gamesGrid": `lE_gfTo4830CiTdj8UeP`
};
export default ___CSS_LOADER_EXPORT___;
